module.exports = __webpack_public_path__ + "img/task2.7aaed7cc.png";